export const GET_FILTERED_RESULT_SETS = "GET_FILTERED_RESULT_SETS";
export const GET_FILTERED_RESULT_SETS_SUCCESS = "GET_FILTERED_RESULT_SETS_SUCCESS";
export const GET_FILTERED_RESULT_SETS_ERROR = "GET_FILTERED_RESULT_SETS_ERROR";
export const GET_WORST_RESULT_SETS = "GET_WORST_RESULT_SETS";
export const GET_WORST_RESULT_SETS_SUCCESS = "GET_WORST_RESULT_SETS_SUCCESS";
export const GET_WORST_RESULT_SETS_ERROR = "GET_WORST_RESULT_SETS_ERROR";